<template>
    <form class="modal" @submit.prevent="submitCreateMachineForm">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Crear máquina</h5>
                    <button @click="closeModal" type="button" class="btn-close" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="row mb-3">
                        <div class="col-md-6">
                            <label for="machineCode" class="form-label">Código</label>
                            <input v-model="form.code" type="text" class="form-control" id="machineCode" required>
                        </div>
                        <div class="col-md-6">
                            <label for="machineType" class="form-label">Tipo</label>
                            <select v-model="form.machine_type_id" class="form-select" id="machineType" required>
                                <option value="" disabled>Seleccione un tipo</option>
                                <option v-for="machineType in machineTypes" :key="machineType.id" :value="machineType.id">
                                    {{ machineType.descrip }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row mb-3 align-items-center">
                        <div class="col-md-8">
                            <label for="machineDescrip" class="form-label">Descripción</label>
                            <input v-model="form.descrip" type="text" class="form-control" id="machineDescrip" required>
                        </div>
                        <div class="col-md-4">
                            <div class="form-check form-switch" style="margin-top: 2rem;">
                                <input type="checkbox" class="form-check-input" v-model="form.has_data_display" id="hasDataDisplay">
                                <label class="form-check-label" for="hasDataDisplay">Mostrar datos</label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-6">
                            <label for="machineTargetOee" class="form-label">Objetivo OEE</label>
                            <input v-model="form.target_oee" type="number" class="form-control" id="machineTargetOee" required>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-12">
                            <label for="mqttMachineId" class="form-label">Código mqtt</label>
                            <input v-model="form.mqtt_machine_id" type="text" class="form-control" id="mqttMachineId">
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button @click="closeModal" type="button" class="btn btn-danger">Cancelar</button>
                    <button type="submit" class="btn btn-success">Crear</button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import axios from 'axios';
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';

export default {
    name: 'MachineCreateModal',
    props: {
        machineTypes: {
            type: Array,
            required: true
        },
        stationId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            form: {
                station_id: this.stationId,
                code: '',
                machine_type_id: '',
                descrip: '',
                has_data_display: false,
                target_oee: '',
                mqtt_machine_id: ''
            },
        }
    },
    methods: {
        submitCreateMachineForm(){
            axios.post('/api/machine', this.form)
                .then(response => {
                    showCustomSuccessSweetAlert('Máquina creada correctamente');
                    this.$emit('machine-created');
                    this.closeModal();
                })
                .catch(error => {
                    showCustomErrorSweetAlert(error.response.data);
                })
        },
        closeModal() {
            this.$emit('close-modal')
        },
    }
}
</script>